module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo1-18335737c6a99b9187419e4d2e23f15e.jpg";